export const shouldLoad = () => document.querySelector('[data-controller="site-header-alt"]') !== undefined;
